// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__36jWk","right":"styles_right__2mDoK"};